export const h = {
	quantity: "Lager",
	brand: "Marke",
	sku: "SKU",
	model: "Model",
	addCart: "Zum Warenkorb hinzufügen",
	buyNow: "Jetzt kaufen",
	productDetail: "Produktdetails",
	attribute: "Attribute",
	quantityExits: "nicht auf Lager",
	quantityNone: "auf Lager",

	// 账单页面
	email: "E-Mail",
	errorEmail: "Bitte gib eine gültige E-Mail-Adresse ein",
	contact: 'Kontakt',
	sippingAddress: 'Lieferadresse',
	name: "Name",
	nameError: "Bitte gib deinen Namen ein",
	address1: "Adresse 1",
	address1Error: "Bitte gib Adresse 1 ein",
	address2: "Adresse 2",
	emailCode: "Postleitzahl",
	phone: "Telefonnummer",
	city: "Stadt",
	cityError: "Bitte gib die Stadt ein",
	country: "Land",
	countryError: "Bitte gib das Land ein",
	province: "Bundesland/Provinz",
	provinceError: "Bitte gib das Bundesland/Provinz ein",
	payWay: "Zahlungsmethode",
	sendWay: "Versandart",
	loginText: "Anmelden / Registrieren",
	cartNum: "Warenkorb insgesamt",
	orderRemarks: "Bestellhinweise",
	discountCode: "Rabattcode eingeben",
	apply: "Anwenden",
	submitOrder: "Bestellung abschicken",

	classify: "Kategorie",
	price: "Preis",
	allNum: "Gesamtanzahl",
	defaultTit: "Standard",
	salesLowToHigh: "Verkäufe (Niedrig - Hoch)",
	salesHighToLow: "Verkäufe (Hoch - Niedrig)",
	nameAtoZ: "Name (A - Z)",
	nameZtoA: "Name (Z - A)",
	priceLowtoHeight: "Preis (Niedrig - Hoch)",
	priceHeighttoLow: "Preis (Hoch - Niedrig)",
	selectClassfiy: "Kategorie auswählen",
	goodCart: "Warenkorb",
	checkout: "Zur Kasse",
	pay: "Bezahlen",
	goods: "Produkt",
	num: "Menge",
	total: "Zwischensumme",
	action: "Aktion",
	del: "Löschen",
	priceTotal: "Gesamtbetrag",
	all: "Alle",
	selectd: "Ausgewählt",
	goCheckout: "Zur Kasse gehen",
	linkGoods: "Ähnliche Produkte",
	noData: "Keine Daten verfügbar",
	myOrder: "Meine Bestellungen",
	changeUserInfo: "Persönliche Daten bearbeiten",
	changePassword: "Passwort ändern",
	myAddress: "Meine Adressen",
	myWishlist: "Meine Wunschliste",
	myRmas: "Mein Kundenservice",
	userCommission: "Mitgliedsprovision",
	commissionUsers: "Mitgliedsbeziehungen",
	loginOut: "Abmelden",
	orderId: "Bestellnummer",

	lookDetail: "Details anzeigen",
	saleService: "Kundenservice anfordern",
	confirmReceivedGoods: "Ware erhalten bestätigen",
	goPay: "Zum Bezahlen",
	cancelOrder: "Bestellung stornieren",

	orderDetail: "Bestelldetails",
	created_at: "Erstellt am",
	status_format: "Bestellstatus",
	total_format: "Bestellbetrag",
	payment_method_name: "Zahlungsmethode",
	shipping_method_name: "Versandart",

	addressInfo: "Adressinformationen",
	name: "Name",
	address: "Adresse",
	payGoods: "Bestellte Produkte",

	sendCompany: "Versandunternehmen",
	sendNum: "Sendungsnummer",
	updateTime: "Aktualisiert am",
	memo: "Bemerkungen",
	payOrderAddress: "Rechnungsadresse",
	allOrder: "Alle Bestellungen",
	waitPay: "Zahlung ausstehend",
	waitSend: "Versand ausstehend",
	waitReceiving: "Erhalt ausstehend",
	completed: "Abgeschlossen",
	confirm: "Bestätigen",
	tips: "Hinweis",
	cancel: "Abbrechen",
	changeHeadImg: "Profilbild ändern",
	uploadTit: "JPEG- oder PNG-Bild hochladen. Empfohlene Größe: 300 x 300.",
	imgSizeTips: "Die Bildgröße darf 2 MB nicht überschreiten!",
	imgTypeTips: "Nur JPG/PNG-Formate erlaubt!",
	serviceType: "Serviceart",
	returnNum: "Rückgabe-/Umtauschmenge",
	isOpend: "Ist die Verpackung geöffnet?",
	returnReason: "Rückgabe-/Umtauschgrund",
	yes: "Ja",
	no: "Nein",
	returnGoods: "Rückgabe",
	exchange: "Umtausch",
	repair: "Reparatur",
	reissue: "Nachsendung",
	refund: "Nur Rückerstattung",
	returnNumError: "Bitte Rückgabe-/Umtauschmenge eingeben",

	oldPassword: "Altes Passwort",
	newPassword: "Neues Passwort",
	confirmNewPassword: "Neues Passwort bestätigen",

	wishlist: "Von Wunschliste entfernen",
	look: "Ansehen",
	opendPkg: "Verpackung geöffnet",
	img: "Bild",
	afterSales: "Kundenservice-Details",

	balance: "Verfügbares Guthaben",
	waitAmount: "Ausstehende Abrechnung",
	withdrawaled: "Ausgezahlt",
	withdrawal: "Auszahlung",
	allCommission: "Gesamtprovision",
	startTime: "Startzeit",
	endTime: "Endzeit",
	search: "Suchen",

	rebateLevel: "Provisionsebene",
	CommissionRate: "Provionssatz",
	commission: "Provision",
	settlementStatus: "Abrechnungsstatus",
	time: "Zeit",
	WithdrawalAmount: "Auszahlungsbetrag",
	peleaseSelect: "Bitte auswählen",
	withdrawalUser: "Auszahlungskonto",
	peleaseIpt: "Bitte eingeben",
	submitSuccess: "Erfolgreich übermittelt",
	shareLink: "Link teilen",
	superior: "Mein direkter Vorgesetzter",
	wu: "Keine",
	subordinate: "Meine Untergebenen",
	addTime: "Beitrittsdatum",
	userAccount: "Konto",
	recommendationCode: "Empfehlungscode",
	copySuccess: "Erfolgreich kopiert",
	subPay: "Zahlung abschicken",
	iptCardholder_Name: "Bitte Namen des Karteninhabers eingeben",

	copy: "Kopie",

	"home": "Startseite",
	"categoriesPage": "Kategorien",
	"brandsPage": "Marken",
	"brandsPageList": "Markenprodukte",
	"productsPage": "Produkte",
	"wishlistPage": "Meine Wunschliste",
	"accountPage": "Meine Bestellungen",
	"cartsPage": "Warenkorb",
	"checkoutPage": "Kasse",
	"passwordPage": "Passwort ändern",
	"editPage": "Informationen bearbeiten",
	"addressesPage": "Adresse bearbeiten",
	"rmasPage": "Mitgliedschaftsbeziehungen",
	"commissionPage": "Mitgliederprovision",
	"success_order_checkoutPage": "Bestellzahlung",
	"page_categoriesPage": "Artikelkategorien",
	"userloginPage": "Anmelden",
	"pagesPage": "Artikel",


	hotGoods: "Beliebte Produkte",
	newGoods: "Neueste Produkte",
	visitGoods: "Am häufigsten angesehen",
	allGoods: "Alle Produkte",
	evaluation: "Bewertungen",

	"first_name": "Nachname",
	"first_nameError": "Bitte geben Sie den Nachnamen ein",
	"last_name": "Vorname",
	"last_nameError": "Bitte geben Sie den Vornamen ein",


	"comment": "Inhalt",
	"noContent": "Noch keine Kommentare",
	"author": "Autor",
	"scoreNum": "Bewertung",
	"commentTit": "Kommentare",

	send: "Senden",
	noPayWay: "Keine verfügbaren Zahlungsmethoden",
	noTransportation: "Keine verfügbaren Versandmethoden",
	
	 "tkyouorder": "Vielen Dank für Ihre Bestellung",
	  "orderDate": "Bestelldatum",
	  "ordeAmount": "Bestellbetrag",
	  "paymentAddress": "Zahlungsadresse",
	  "zipCode": "Postleitzahl"
}